import { Link } from "react-router-dom";
import { Receipt } from "lucide-react";
import { fmtPrice } from "@/lib/constants";
import { Panel, PanelLink } from "./parts";

const pl = (n, one, many) => `${n} ${n > 1 ? many : one}`;

const Tile = ({ to, count, amount, amountTone, extra, testid }) => (
  <Link to={to} data-testid={testid}
    className="block rounded-xl border border-white/[0.07] bg-[#122549]/60 p-4 transition-colors duration-150 hover:border-cyan-400/40 hover:bg-[#122549]">
    <p className="font-display text-xl font-semibold text-white" data-testid={`${testid}-count`}>{count}</p>
    <p className={`mt-1 text-base font-medium tabular-nums ${amountTone}`} data-testid={`${testid}-amount`}>{amount}</p>
    {extra}
  </Link>
);

const toBillAmount = (n, amount, unpriced, covered) => {
  if (!n) return ["Rien à facturer", "text-slate-500"];
  if (unpriced >= n) return ["Montant à déterminer", "text-amber-300"];
  if (unpriced + covered >= n) return unpriced ? ["Montant à déterminer", "text-amber-300"] : ["0,00 € · couvert par contrat", "text-emerald-300"];
  return [`${fmtPrice(amount)} à facturer`, "text-amber-300"];
};

export const BillingZone = ({ c, s, v3 }) => {
  const n = c.to_bill || 0;
  const [amount, tone] = toBillAmount(n, s.to_bill_amount, s.to_bill_unpriced || 0, s.to_bill_covered || 0);
  const partial = n > 0 && s.to_bill_unpriced > 0 && s.to_bill_unpriced < n;
  const late = v3?.invoices_late || 0;
  return (
    <Panel title="Facturation" icon={Receipt} testid="zone-billing" action={<PanelLink to="/facturation" testid="billing-detail-link">Voir le détail</PanelLink>}>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
        <Tile to="/interventions?cat=to_bill" testid="kpi-to-bill" count={n ? pl(n, "intervention", "interventions") : "Aucune intervention"} amount={amount} amountTone={tone}
          extra={<>
            {partial && <p className="mt-1 text-xs text-amber-200/80" data-testid="kpi-to-bill-unpriced">+ {pl(s.to_bill_unpriced, "montant à déterminer", "montants à déterminer")}</p>}
            {v3?.out_of_contract_to_bill > 0 && <p className="mt-1 text-xs text-slate-400" data-testid="kpi-to-bill-out">dont {v3.out_of_contract_to_bill} hors contrat</p>}
          </>} />
        <Tile to="/facturation?tab=payments&pay=en_retard" testid="kpi-invoices-late" count={late ? pl(late, "paiement en retard", "paiements en retard") : "Aucun paiement en retard"}
          amount={late ? `${fmtPrice(v3.invoices_remaining)} reste dû` : "Tout est à jour"} amountTone={late ? "text-red-300" : "text-emerald-300"} />
      </div>
    </Panel>
  );
};
